import React, { useState, useMemo, useEffect, Fragment, memo } from "react";
import { useTable, useSortBy } from "react-table";
import { FaSortDown, FaSortUp } from "react-icons/fa";
import "react-toastify/dist/ReactToastify.css";
import { SwalWarn } from "../../Popup";
import { ccmodeUserTableColumns } from "./CcmodeUserTableColumns";
import ApiDataSkeleton from "../CCModeTable/ApiDataSkeleton";
import axios from "axios";
import { NODE_API_URL, BASE_URL } from "../../../../env_config";
import Cookies from "js-cookie";
import { makeStyles, styled } from "@material-ui/core";
import { toast } from "react-toastify";

const Styles = styled("div")(({ theme }) => ({
    "& th:first-child, & td:first-child": {
        [theme.breakpoints.up("xs")]: {
            paddingLeft: `3rem !important`,
        },
        [theme.breakpoints.up("md")]: {
            paddingLeft: `6rem !important`,
        },
    },
    "& td": {
        [theme.breakpoints.up("xs")]: {
            paddingTop: ".55rem !important",
            paddingBottom: ".55rem !important",
        },
        [theme.breakpoints.up("md")]: {
            paddingTop: ".55rem !important",
            paddingBottom: ".55rem !important",
        },
    },
}));

const useStyles = makeStyles((theme) => ({
    tableRow: {
        fontFamily: 'Rubik,sans-serif !important',
        fontSize: "14px !important",
    },
    mutedRow: {
        background: "#F6F8FA",
        // transition: "background 0.3s ease-in-out",
        // "&:hover": {
        //     background: "hsl(0 0 90%) !important",
        // },
    },
    maxContent: {
        width: "max-content",
        whiteSpace: "nowrap",
    },
}));

const CcmodeUserTable = ({ setInviteUserForm, setUpdatePassword }) => {
    const classes = useStyles();

    const [refreshUser, setRefreshUser] = useState(0);
    const [swalopen, setSwalOpen] = useState(false);
    const [recoverObj, setRecoverObj] = useState({
        open: false,
        userId: null,
    });
    const [deleteObj, setDeleteObj] = useState(null);

    const [data, setData] = useState(null);

    useEffect(() => {
        const source = axios.CancelToken.source();
        axios({
            method: "GET",
            url: `${NODE_API_URL}/INTL/fetch-ccmode-users`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
            cancelToken: source.token,
        })
            .then((res) => {
                if (res.data.success) {
                    setData(
                        res.data.data.map((el) => ({
                            ...el,
                            permissions: JSON.parse(el.permissions),
                        }))
                    );
                }
            })
            .catch((error) => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
                if (error?.response?.data?.message) {
                    toast.error(error?.response?.data?.message);
                }
            });

        return () => {
            source.cancel("Component unmounted: cancel pending request");
        };
    }, [refreshUser]);

    const handleToggle = (user) => {
        axios({
            method: "PATCH",
            url: `${NODE_API_URL}/INTL/update-ccmode-user/${user.id}`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
            data: {
                customer_id: user.customer_id,
                is_active: !user.is_active,
            },
        })
            .then((res) => {
                if (res.data.success) {
                    toast.dismiss();
                    toast.success(res.data?.message);
                    setInviteUserForm((prev) => ({
                        ...prev,
                        isOpen: false,
                        isUpdating: false,
                    }));
                    setRefreshUser((prev) => prev + 1);
                }
            })
            .catch((error) => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
                if (error?.response?.data?.message) {
                    toast.error(error?.response?.data?.message);
                }
            });
    };

    const recoverDeletedUser = () => {
        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/undelete-user/${recoverObj.userId}`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
        })
            .then((res) => {
                if (res.data.success) {
                    toast.dismiss();
                    toast.success(res.data?.message);
                    setInviteUserForm((prev) => ({
                        ...prev,
                        isOpen: false,
                        isUpdating: false,
                    }));
                    setRefreshUser((prev) => prev + 1);
                }
            })
            .catch((error) => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
                if (error?.response?.data?.message) {
                    toast.error(error?.response?.data?.message);
                }
            })
            .finally(() => setRecoverObj({ open: false, userId: null }));
    };

    const columns = useMemo(
        () =>
            ccmodeUserTableColumns(
                setDeleteObj,
                setSwalOpen,
                handleToggle,
                setInviteUserForm,
                setUpdatePassword,
                setRecoverObj
            ),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const tableInstance = useTable(
        {
            columns,
            data: data || [],
        },
        useSortBy
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = tableInstance;

    const DeleteUser = () => {
        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/delete-user/${deleteObj.id}`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
        })
            .then((res) => {
                if (res.data.success) {
                    toast.dismiss();
                    toast.success("User Deactivated");
                    setInviteUserForm((prev) => ({
                        ...prev,
                        isOpen: false,
                        isUpdating: false,
                    }));
                    setRefreshUser((prev) => prev + 1);
                }
            })
            .catch((error) => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
                if (error?.response?.data?.message) {
                    toast.error(error?.response?.data?.message);
                }
            })
            .finally(() => {
                setSwalOpen(false);
            });
    };

    return (
        <>
            {!data ? (
                <ApiDataSkeleton />
            ) : (
                <Styles>
                    <div className="pt-5 pb-0">
                        <SwalWarn
                            show={swalopen}
                            message={"Are you sure want to delete user?"}
                            onHide={() => setSwalOpen(false)}
                            onClose={() => setSwalOpen(false)}
                            responseOnOk={DeleteUser}
                        />
                        <SwalWarn
                            show={recoverObj.open}
                            message={"Are you sure want to recover user?"}
                            onHide={() =>
                                setRecoverObj({ open: false, userId: null })
                            }
                            onClose={() =>
                                setRecoverObj({ open: false, userId: null })
                            }
                            responseOnOk={recoverDeletedUser}
                        />
                        <div className="table-responsive w-100">
                            <table
                                className="table table-hover"
                                {...getTableProps()}
                            >
                                <thead className="custom_datatable_head">
                                    {headerGroups.map((headerGroup) => (
                                        <tr
                                            {...headerGroup.getHeaderGroupProps()}
                                        >
                                            {headerGroup.headers.map(
                                                (column, j) => (
                                                    <th
                                                        className={`${column.className}`}
                                                        {...column.getHeaderProps(
                                                            column.getSortByToggleProps()
                                                        )}
                                                    >
                                                        {column.render(
                                                            "Header"
                                                        )}
                                                        <span className="text-secondary">
                                                            {column.isSorted ? (
                                                                column.isSortedDesc ? (
                                                                    <FaSortDown />
                                                                ) : (
                                                                    <FaSortUp />
                                                                )
                                                            ) : (
                                                                ""
                                                            )}
                                                        </span>
                                                    </th>
                                                )
                                            )}
                                        </tr>
                                    ))}
                                </thead>
                                <tbody {...getTableBodyProps()}>
                                    {rows.length ? (
                                        rows.map((row, i) => {
                                            prepareRow(row);
                                            return (
                                                <Fragment key={i}>
                                                    <tr
                                                        {...row.getRowProps()}
                                                        className={`${
                                                            row.original
                                                                .is_default_user
                                                                ? classes.mutedRow
                                                                : "py-5"
                                                        } ${
                                                            classes.maxContent
                                                        }`}
                                                    >
                                                        {row.cells.map(
                                                            (cell, i) => {
                                                                return (
                                                                    <td
                                                                        {...cell.getCellProps(
                                                                            {
                                                                                className: `${cell.column.className} ${classes.tableRow} border-bottom`,
                                                                            }
                                                                        )}
                                                                        key={i}
                                                                    >
                                                                        {cell.render(
                                                                            "Cell"
                                                                        )}
                                                                    </td>
                                                                );
                                                            }
                                                        )}
                                                    </tr>
                                                </Fragment>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td
                                                className="text-center bg-gray-200"
                                                colSpan="100%"
                                            >
                                                No User Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Styles>
            )}
        </>
    );
};

export default memo(CcmodeUserTable);
